import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AgmCoreModule } from '@agm/core';
import { AllComponentsComponent } from './all-components/all-components.component';
import { AgentEnquiryComponent } from './agent/agent-enquiry/agent-enquiry.component';


import { CCustomerComponent } from './Components/Customer/c-customer/c-customer.component';
import { VCustomerComponent } from './Components/Customer/v-customer/v-customer.component';
import { CCustomerinformationComponent } from './Components/CustomerInformation/c-customerinformation/c-customerinformation.component';
import { VCustomerinformationComponent } from './Components/CustomerInformation/v-customerinformation/v-customerinformation.component';
import { CDashboardComponent } from './Components/Dashboard/c-dashboard/c-dashboard.component';
import { CServicelocationComponent } from './Components/ServiceLocation&Operations/c-servicelocation/c-servicelocation.component';
import { CStockkeepingunitComponent } from './Components/StockKeepingUnit/c-stockkeepingunit/c-stockkeepingunit.component';
import { CCostingComponent } from './Components/Costing/c-costing/c-costing.component';
import { CExistingvendorComponent } from './Components/ExistingVendor/c-existingvendor/c-existingvendor.component';
import { CTradereferenceComponent } from './Components/TradeReference/c-tradereference/c-tradereference.component';
import { CPrequotesignoffComponent } from './Components/Pre-QuoteSignOff/c-prequotesignoff/c-prequotesignoff.component';
import { CPrequotecontractconversionComponent } from './Components/Pre-Quote to Contract Conversion/c-prequotecontractconversion/c-prequotecontractconversion.component';
import { ReportapprovalComponent } from './Components/ReportApproval/reportapproval/reportapproval.component';
import { PrequoteComponent } from './Components/Pre_Quote/prequote/prequote.component';
import { VPrequoteComponent } from './Components/Pre_Quote/v-prequote/v-prequote.component';
import { ReportComponent } from './Components/Report/report/report.component';
import { VApprovalComponent } from './Components/Approval/v-approval/v-approval.component';
import { LandingpageComponent } from './Components/landingpage/landingpage.component';
import { VPrequotecontractconversionComponent } from './Components/Pre-Quote to Contract Conversion/v-prequotecontractconversion/v-prequotecontractconversion.component';
import { ViewprequoteComponent } from './Components/Pre_Quote/viewprequote/viewprequote.component';
import { CCustomerContractComponent } from './Components/CustomerContract/c-customer-contract/c-customer-contract.component';
import { VCustomerContractComponent } from './Components/CustomerContract/v-customer-contract/v-customer-contract.component';




const routes: Routes = [
  {path:'all-components',component:AllComponentsComponent},
  {path:'AgentEnquiry', component: AgentEnquiryComponent},
  // {path:'cCustomer', component: CCustomerComponent},
  // {path:'vCustomer', component: VCustomerComponent},
  // {path:'cManageCustomer', component: CManagecustomerComponent},
  // {path:'vManageCustomer', component: VManagecustomerComponent},


  {path:'cCustomer',component:CCustomerComponent},
  {path:'vCustomer',component:VCustomerComponent},
  {path:'cCustomerinformation',component:CCustomerinformationComponent},
  {path:'vCustomerinformation',component:VCustomerinformationComponent},
  {path:'cDashboard',component:CDashboardComponent},
  {path:'cServiceLocation',component:CServicelocationComponent},
  {path:'cStockkeepingunit',component:CStockkeepingunitComponent},
  {path:'cCosting',component:CCostingComponent},
  {path:'cExistingvendor',component:CExistingvendorComponent},
  {path:'cTradereference',component:CTradereferenceComponent},
  {path:'cPrequotesignoff',component:CPrequotesignoffComponent},
  {path:'cPrequotecontractconversion',component:CPrequotecontractconversionComponent},
  {path:'Reportapproval',component:ReportapprovalComponent},
  {path:'prequote',component:PrequoteComponent},
  {path:'vprequote',component:VPrequoteComponent},
  {path:'vApproval',component:VApprovalComponent},
  {path:'Report',component:ReportComponent},
  {path:'',component:LandingpageComponent},
  {path:'vPrequotecontractconversion',component:VPrequotecontractconversionComponent},
  {path:'viewprequote',component:ViewprequoteComponent},

  {path:'ccustomercontract',component:CCustomerContractComponent},
  {path:'vcustomercontract',component:VCustomerContractComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
